<template>
  <el-select
    :disabled="isDisabled"
    :loading="loading"
    @focus="getList"
    :filter-method="pharmacyRemote"
    filterable
    :clearable="ifClearable"
    class="search-select"
    v-model="value"
    :placeholder="placeholder"
    @change="selectChange"
    :multiple="$attrs.multiple"
    :size="$attrs.size"
  >
    <el-option
      v-for="item in list"
      :key="item[prop.code]"
      :label="item[prop.label]"
      :value="item[prop.code]"
    ></el-option>
  </el-select>
</template>

<script>
/**
 * @description:
 * @param {type}
 * @emit dic-select-obj 返回选中对象
 * @props {fuzzyDef} 请求实体, {prop}  key value对应关系 ,{ajaxQuery} 搜索关键字key, {defaultActive} 默认值并选中, {ajaxQueryObj} 请求扩展参数,isDisabled 禁用}
 */
import { debounce } from 'lodash';
import { dicQueryList } from '@/api/ajax';

export default {
  props: {
    // 传递index
    ifClearable: {
      type: Boolean,
      default: true
    },
    No: {
      type: Number,
      default: -1
    },
    // 至空
    setEmpty: {
      type: Number,
      default: 0
    },
    dictType: {
      // 搜索类型
      type: String,
      default: ''
    },
    dicDefaultType: {
      type: String,
      default: 'dictType'
    },
    placeholder: {
      type: String,
      default: ''
    },
    // 默认赋值并被选中
    defaultActive: {
      type: Object,
      default() {
        return {
          dict_name: '',
          dict_code: ''
        };
      }
    },
    // 映射
    prop: {
      type: Object,
      default() {
        return {
          code: 'dict_code',
          label: 'dict_name'
        };
      }
    },
    // 搜索key
    ajaxQuery: {
      type: String,
      default: 'dictName'
    },
    // 查询条件 扩展字段 only为true则以此为实体不混合 默认false
    ajaxQueryObj: {
      type: Object,
      default() {
        return { only: false };
      }
    },
    // 请求方法
    fuzzyDef: {
      type: Function,
      default() {
        return new Promise((resolve, reject) => {
          reject();
        });
      }
    },
    // 是否 禁用
    isDisabled: {
      type: Boolean,
      default: false
    },
    // 扩展提交字段 与 ajaxQueryObj 一样 不过没有only，可以不用
    assginParams: {
      type: Object,
      default() {
        return {};
      }
    },
    // 校验
    needCheck: {
      type: Object,
      default() {
        return {
          need: false, // 是否需要
          toast: '', // 校验错误提示
          fieldValue: '' // 值 如果需要校验 必须有值
        };
      }
    }
  },
  data() {
    return {
      value: '',
      list: [],
      loading: false
    };
  },
  watch: {
    defaultActive: {
      deep: true,
      immediate: true,
      handler(v) {
        if (v && this.prop && v[this.prop.code]) {
          this.getList();
        }
      }
    },
    setEmpty(v) {
      if (v) {
        this.value = '';
      }
    }
  },
  methods: {
    selectChange(val) {
      let filterItem = {};
      this.list.filter(item => {
        if (item[this.prop.code] == val) {
          filterItem = item;
        }
      });
      //传递index
      if (this.No > -1) {
        filterItem.No = this.No;
      }
      this.$emit('dic-select-obj', filterItem); // 返回当前的obj
      this.$emit('dic-select', val); // 只返回value
    },
    init() {
      this.value = '';
      this.getList();
    },
    getList(queryName = '') {
      if (
        !this.needCheck.need ||
        (this.needCheck.need && this.needCheck.fieldValue)
      ) {
        this.loading = true;
        let obj = this.ajaxQueryObj.only
          ? this.ajaxQueryObj
          : Object.assign(
              {
                pageNum: 1,
                pageNo: 1,
                pageSize: 80,
                [this.dicDefaultType]: this.dictType,
                [this.ajaxQuery]:
                  typeof queryName === 'object' ? '' : queryName,
                ...this.assginParams
              },
              this.ajaxQueryObj
            );
        this.fuzzyDef(obj).then(res => {
          this.loading = false;
          if (res.data.data) {
            this.list = res.data.data.list || res.data.data;
            // 如果有并且当前选中为空
            if (this.defaultActive[this.prop.code] && !this.value) {
              let next = true;
              this.list.filter(item => {
                // 存在
                if (
                  item[this.prop.code] == this.defaultActive[this.prop.code]
                ) {
                  next = false;
                }
              });
              // 不存在PUSH
              if (next) {
                this.list.unshift(this.defaultActive);
              }
              // 赋默认值
              this.value = this.defaultActive[this.prop.code];
            }
          }
        });
      } else {
        this.$notify({
          title: '失败',
          message: this.needCheck.toast,
          type: 'error'
        });
      }
    },
    // select搜索
    pharmacyRemote: debounce(function(query) {
      this.getList(query);
    }, 200)
  },
  created() {}
};
</script>

<style lang="scss"></style>
